import HotelsCityLocationPage, { getServerSideProps } from '../../shared/city-location';

export { getServerSideProps };
export default HotelsCityLocationPage;
